"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var dialogContent =
/*#__PURE__*/
(0, _reactEmotion.css)("background-color:", _themeConfig.default.color.dark.saturn, ";box-shadow:0px 10px 50px hsla(0,0%,0%,0.33);position:relative;padding:20px;");
var closeDialogButton =
/*#__PURE__*/
(0, _reactEmotion.css)("position:absolute;top:10px;right:10px;");
var closeDialogButtonIcon =
/*#__PURE__*/
(0, _reactEmotion.css)("fill:white;");
var _default = {
  dialogContent: dialogContent,
  closeDialogButton: closeDialogButton,
  closeDialogButtonIcon: closeDialogButtonIcon
};
exports.default = _default;